const { BOOSTER_FLD_PFX } = require('./constants');

const getBoostFieldName = (fldName) => `${BOOSTER_FLD_PFX}${fldName}`;

const getBoostSet = (fldName, obj) => {
	return obj?.[getBoostFieldName(fldName)];
};

const withoutBoostFieldName = (s) => (s.startsWith(BOOSTER_FLD_PFX) ? s.slice(BOOSTER_FLD_PFX.length) : s);

const ORDER = ['parentIdx', 'value', 'featureIdx', 'missingNumericalIsLeft'];

class NodeArrWrapper {
	constructor(arr = []) {
		this.arr = arr;
	}

	get isLeaf() {
		return this.arr.length <= 2;
	}

	plain() {
		const { arr, isLeaf } = this;
		const res = { arr, isLeaf };
		ORDER.slice(0, this.arr.length).forEach((key, i) => {
			res[key] = this.arr[i];
		});
		return res;
	}
}

ORDER.forEach((key, i) => Object.defineProperty(NodeArrWrapper.prototype, key, {
	get() {
		return this.arr[i];
	},
	set(v) {
		this.arr[i] = v;
	},
	enumerable: true,
}));

module.exports = {
	getBoostFieldName,
	getBoostSet,
	withoutBoostFieldName,
	NodeArrWrapper,
};
